export default {
  nav: {
    overview: "Overview",
    profile: "Profile",
    portfolio: "Portfolio",
    awards: "Awards",
    application: "Union application",
    deposits: "Deposits",
    events: "Events",
  },
  noProfile: "Writer profile is not created yet.",
  createProfile: "Fill in the profile",
  membership: "Membership status",
  status: {
    none: "no application",
    candidate: "candidate",
    member: "union member",
    rejected: "rejected",
    suspended: "suspended",
  },
  fields: {
    lastName: "Last name",
    firstName: "First name",
    patronymic: "Patronymic",
    displayName: "Full name",
    pseudonym: "Pen name",
    region: "Region",
    bio: "Biography",
    workTitle: "Work title",
    awardTitle: "Award",
  },
  portfolioEmpty: "Portfolio is empty.",
  applicationHint: "Apply to the Writers Union after completing your profile.",
  noApplication: "No application yet.",
  submitApplication: "Submit application",
  applicationStatus: "Application status: {{status}}",
  overview: {
    welcome: "Hello, {{name}}!",
    welcomeHint: "Your writer profile, portfolio, awards and union application in one place.",
    anketaHint: "A complete profile is required to apply to the union and to appear in the writers registry.",
    membershipLabel: "Union membership",
    cardNo: "Card No. {{no}}",
    joinedYear: "member since {{year}}",
    statsTitle: "Summary",
    worksTitle: "Works",
    worksHint: "Works in your portfolio and their verification status.",
    worksTotal: "Total",
    worksVerified: "Verified",
    worksPending: "Pending",
    awardsTitle: "Awards",
    awardsHint: "Prizes, contests and diplomas.",
    awardsTotal: "Total",
    awardsLatest: "Latest",
    servicesTitle: "Quick actions",
    services: {
      profile: { title: "Profile", desc: "Name, pen name, region and biography." },
      portfolio: { title: "Portfolio", desc: "Add a work for union verification." },
      application: { title: "Union application", desc: "Apply and follow the decision." },
      deposit: { title: "Deposits", desc: "Deposit a copy to the national collection." },
    },
    noProfileTitle: "Writer profile is not filled in yet",
    noProfileHint: "Without a profile you cannot apply to the union or keep a portfolio.",
  },
  profile: {
    subtitle: "The union and, if you allow, registry visitors will see this information.",
    sections: {
      name: "Name and pen name",
      about: "About",
      visibility: "Visibility",
    },
    isPublic: "Show my card in the writers registry",
    isPublicHint: "The card will appear in the Writers section of the site.",
    bioHint: "A few paragraphs about your creative path.",
  },
  portfolio: {
    subtitle: "Works are verified by the union before they appear in the registry.",
    add: "Add work",
    addTitle: "New work",
    emptyTitle: "Portfolio is empty",
    emptyHint: "Add your first work and the union will verify your authorship.",
    search: "Find in the catalog",
    searchPlaceholder: "Title or ISBN",
    searchEmpty: "Nothing in the catalog — fill in the fields below",
    searchLoading: "Searching…",
    catalogHint: "After the union verifies it, this work will list you as the author in the catalog.",
    isbn: "ISBN",
    isbnInvalid: "Enter a 10- or 13-digit ISBN",
    columns: { title: "Title", status: "Verification", added: "Added" },
    verification: {
      pending: "pending",
      verified: "verified",
      rejected: "rejected",
    },
  },
  awards: {
    subtitle: "Prizes, contests and diplomas will appear on your writer card.",
    add: "Add award",
    addTitle: "New award",
    year: "Year",
    yearInvalid: "Enter a four-digit year",
    emptyTitle: "No awards yet",
    emptyHint: "Add a prize or diploma to show it in your profile.",
    columns: { title: "Award", year: "Year", added: "Added" },
  },
  application: {
    subtitle: "Joining the Writers Union: from profile to decision.",
    steps: {
      profile: "Profile completed",
      submitted: "Application submitted",
      decision: "Union decision",
    },
    submittedAt: "Submitted {{date}}",
    decidedAt: "Decided {{date}}",
    note: "Union comment",
    needProfile: "Fill in your writer profile first.",
  },
}
